import { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import styles from './ExportExcelButton.module.css';

// Downloads an .xlsx from `url` (the server decides the filename via Content-Disposition)
function ExportExcelButton({ url, fallbackFileName = 'devices.xlsx', disabled = false, label = 'Download Excel' }) {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async () => {
    setExporting(true);
    setError(null);
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Export failed (${res.status})`);

      const blob = await res.blob();
      const fileName = /filename="?([^"]+)"?/.exec(res.headers.get('Content-Disposition') || '')?.[1]
        ?? fallbackFileName;

      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      setError('Could not download the device list. Please try again.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {error && <span className={styles.error}>{error}</span>}
      <button className={styles.btn} onClick={handleExport} disabled={disabled || exporting}>
        <AiOutlineDownload size={15} />
        {exporting ? 'Preparing…' : label}
      </button>
    </div>
  );
}

export default ExportExcelButton;
